export { default } from './Local';
